export { default } from './Local';
